export default __webpack_public_path__ + "static/media/2_ЗГ_ын_тогтоол,_журмын_танилцуулга.be8ad999.pptx";